module.exports = __webpack_public_path__ + "static/media/911CallDetectedReadout.6647586b.mp3";